<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
import Dashboard from './Dashboard'
export default {
  name: 'Homepage',
  components: {
    Dashboard,
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/containers/Homepage.vue